import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleXmark,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";

export function BinaryStatusGoodBad({
  verdict,
  badOption,
  goodOption,
}: {
  verdict: boolean;
  goodOption: string;
  badOption: string;
}) {
  return (
    <div
      className={`flex font-bold text-xs items-center ${
        !verdict ? "text-status-pending-1" : "text-status-success"
      } `}
    >
      <div className={"mr-1"}>
        {!verdict ? (
          <FontAwesomeIcon
            className={"text-status-pending-1"}
            icon={faTriangleExclamation}
          />
        ) : (
          <FontAwesomeIcon
            className={"text-status-success"}
            icon={faCircleCheck}
          />
        )}
      </div>
      {!verdict ? badOption : goodOption}
    </div>
  );
}
